import "./components/access-control";
import "./components/vlb";
import {format} from "date-fns";
import {reportsFunctions} from "./admin-reports";

window.format = format;
window.reportsFunctions = reportsFunctions;

if (module.hot) {
	module.hot.accept();
}
